import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "io-container container-fluid" }

import {
  computed,
  useSlots,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Container',
  props: {
  width: {
    type: String,
    default: 'default',
  },
  align: {
    type: String,
    default: 'none',
  },
  useHeadline: {
    type: String,
    default: '0',
  },
  headlineAlign: {
    type: String,
    default: 'start',
  },
},
  setup(__props) {

const props = __props;

const colClass = computed<string[]>(() => {
  const colClasses = ['col-12 order-lg-1'];

  if (props.useHeadline === '1' && ['start', 'end'].indexOf(props.align) >= 0) {
    colClasses.push('col-lg-7 col-xl-8');
  } else if (props.width === 'default') {
    colClasses.push('col-md-10 col-lg-9');
  } else if (props.width === 'small') {
    colClasses.push('col-md-9 col-lg-7');
  } else if (props.width === 'wide') {
    colClasses.push('col-md-10');
  }

  return colClasses;
});

const slots = useSlots();
const textContent = slots.text ? slots.text() : null;
const hasTextContent = computed(() => (
  textContent && textContent[0] ? `${textContent[0].children}`.trim().length > 0 : false
));

return (_ctx: any,_cache: any) => {
  const _component_IoHeadline = _resolveComponent("IoHeadline")!
  const _component_BaseSpacer = _resolveComponent("BaseSpacer")!
  const _component_IoText = _resolveComponent("IoText")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["row g-4 g-xl-5 io-eq", `justify-content-${__props.align}`])
    }, [
      (__props.useHeadline === '1' && ['start', 'end'].indexOf(__props.align) >= 0)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["col-12 col-lg-5 col-xl-4", __props.align === 'end' ? 'order-lg-2' : 'order-lg-0'])
          }, [
            _createVNode(_component_IoHeadline, {
              size: "h2",
              "text-align": __props.headlineAlign
            }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "headline")
              ]),
              _: 3
            }, 8, ["text-align"]),
            (hasTextContent.value)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_BaseSpacer),
                  _createVNode(_component_IoText, { "text-align": __props.headlineAlign }, {
                    default: _withCtx(() => [
                      _renderSlot(_ctx.$slots, "text")
                    ]),
                    _: 3
                  }, 8, ["text-align"])
                ], 64))
              : _createCommentVNode("", true)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(colClass.value)
      }, [
        (__props.useHeadline === '1' && __props.align === 'center')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_IoHeadline, {
                size: "h2",
                "text-align": __props.headlineAlign
              }, {
                default: _withCtx(() => [
                  _renderSlot(_ctx.$slots, "headline")
                ]),
                _: 3
              }, 8, ["text-align"]),
              _createVNode(_component_BaseSpacer),
              (hasTextContent.value)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_IoText, { "text-align": __props.headlineAlign }, {
                      default: _withCtx(() => [
                        _renderSlot(_ctx.$slots, "text")
                      ]),
                      _: 3
                    }, 8, ["text-align"]),
                    _createVNode(_component_BaseSpacer)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        _renderSlot(_ctx.$slots, "default")
      ], 2)
    ], 2)
  ]))
}
}

})